
import RadioButton from '@/components/elements/InputRadioButton.vue'
import { SetupContext } from 'vue'

export default {
  name: 'FormRadioButtons',

  components: {
    RadioButton
  },

  props: {
    name: String,
    currentValue: String,
    items: Array
  },

  setup(props: any, context: SetupContext) {
    const callInputChange = (value: string) => {
      context.emit('change-value', value)
    }

    return {
      callInputChange
    }
  }
}
